import styled from '@emotion/styled';

import { su } from '../../theme/functions/su';
import { theme } from '../../theme/theme';

export function Header(props) {
  return (
    <Header.Root>
      <Header.Children>{props.children}</Header.Children>
    </Header.Root>
  );
}

Header.Root = styled.header`
  pointer-events: auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: ${su(9)};
  padding-top: ${su(2)};
  padding-bottom: ${su(2)};
`;

Header.Children = styled.div`
  z-index: ${theme.zIndex.header};
`;
